"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHARSET = void 0;
exports.randomString = randomString;
exports.DEFAULT_CHARSET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
// From: https://stackoverflow.com/questions/10726909/random-alpha-numeric-string-in-javascript
function randomString(length, charset = exports.DEFAULT_CHARSET) {
    let result = '';
    for (let i = 0; i < length; ++i) {
        result += charset[Math.floor(Math.random() * charset.length)];
    }
    return result;
}
//# sourceMappingURL=randomString.js.map